import React from 'react';
import Box from '@mui/material/Box';
import ReactCountryFlag from 'react-country-flag';
import Divider from '@mui/material/Divider';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import { ListItemButton } from 'gatsby-theme-material-ui';
import { useLocation } from '@reach/router';
import PropTypes from 'prop-types';
import { LocaleContext } from '../../../contexts/language';

export const DrawerContent = ({ onToggle, drawerMenuItems }) => {
  const location = useLocation();
  const { pathname, search } = location;

  const localeConfig = React.useContext(LocaleContext);
  const path = localeConfig.lang === 'en' ? pathname : pathname.slice(3);
  const langs = [
    { lang: 'en', prefix: '', name: 'English', country: 'GB' },
    { lang: 'ar', prefix: '/ar', name: 'العربية', country: 'AE' }
  ];
  const urls = langs.map(({ prefix, ...rest }) => {
    return {
      url: `${prefix}${path}${search}`,
      ...rest
    };
  });

  return (
    <Box onClick={onToggle} sx={{ textAlign: 'center' }}>
      <List>
        {drawerMenuItems?.map(({ id, linkText, linkTitle, url, onClick }) => (
          <ListItem key={id} disablePadding>
            <ListItemButton
              to={url}
              onClick={onClick}
              title={linkTitle}
              sx={{   color: 'primary.main' }}>
              {linkText}
            </ListItemButton>
          </ListItem>
        ))}
      </List>
      <Divider />
      <List>
        {urls.map(({ name, country, url }, k) => (
          <ListItem key={k} disablePadding>
            <ListItemButton sx={{   color: 'primary.main' }} to={url} >
              <ListItemText primary={(
                <>
                  <ReactCountryFlag
                    aria-label={name}
                    alt={`Switch language to: ${name}`}
                    countryCode={country}
                    svg
                  /> &nbsp; {name}
                </>
              )}
              />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Box>
  );
};

DrawerContent.propTypes = {
  onToggle: PropTypes.func.isRequired,
  drawerMenuItems: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      linkText: PropTypes.string.isRequired,
      linkTitle: PropTypes.string.isRequired,
      url: PropTypes.string.isRequired
    })
  )
};